"use client";

import { Package, Truck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section data-section-id="231036" id="call-to-action" ref={sectionRef} className="bg-slate-950 text-white relative overflow-hidden py-24 px-4 md:py-36">
      {}
      <div className="pointer-events-none absolute inset-0 z-0" style={{
      background: "radial-gradient(ellipse 70% 60% at 50% 50%, hsla(207, 70%, 39%, 0.25) 0%, hsla(207, 70%, 20%, 0.1) 45%, transparent 75%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-5" style={{
      backgroundImage: "linear-gradient(var(--primary) 1px, transparent 1px), linear-gradient(90deg, var(--primary) 1px, transparent 1px)",
      backgroundSize: "60px 60px"
    }} />

      {}
      <div className={`relative z-10 mx-auto max-w-5xl flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <h2 className="font-default font-bold tracking-tighter leading-none select-none mb-4" style={{
        fontSize: "clamp(52px, 10vw, 80px)",
        color: "hsla(0, 0%, 100%, 0.1)",
        letterSpacing: "-0.03em"
      }}>
          Ready to start?
        </h2>

        {}
        <p className="font-default text-lg md:text-xl max-w-xl mb-12 text-slate-300">
          Ready to start your project? Get in touch with our experts today for a 
          comprehensive consultation and a detailed project roadmap.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-5 w-full max-w-xl justify-center">
          {}
          <Button asChild size="lg" className="flex-1 h-16 text-base md:text-lg font-semibold rounded-lg shadow-lg gap-3 font-default bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white border-none">
            <Link to="#">
              <Package className="size-5 shrink-0" />
              Request Free Estimate
            </Link>
          </Button>

          {}
          <Button asChild variant="outline" size="lg" className="flex-1 h-16 text-base md:text-lg font-semibold rounded-lg gap-3 font-default border-white/20 text-white bg-white/5 hover:bg-white/10 backdrop-blur-sm shadow-md">
            <Link to="tel:2017364633">
              <Truck className="size-5 shrink-0" />
              201-736-4633
            </Link>
          </Button>
        </div>

        {}
        <p className="mt-10 text-sm tracking-widest uppercase font-default text-slate-400">
          Secondary Contact: 646-406-4601 &mdash; Available 24/7
        </p>
      </div>

      {}
      <div className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-32 opacity-30 blur-3xl z-0 bg-blue-600" />
    </section>;
}